import { render, staticRenderFns } from "./IconGraphy.vue?vue&type=template&id=83ed174c&"
import script from "./IconGraphy.vue?vue&type=script&lang=ts&"
export * from "./IconGraphy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports